/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */

/**
 *
 * @author Yakov Gushchin
 * @author Mikhail Kokoulin
 * @author Aleksandr Perkhunov
 * @version 1.12.0
 * @since 1.0.0
 */

import { select } from 'redux-saga/effects';

import { AuthMenuEnum } from '../../../../pages/PageAuth/constants/authConstants';
import { makeSelectAuthMenu } from '../../../../pages/PageAuth/selectors/authSelectors';
import { IAuthMenu } from '../../../../pages/PageAuth/types/authTypes';
import { AccessComponentKeyEnum } from '../../constants/guard/guardConstants';

export function* IsTabMenuItemOnceConditionSaga(componentKey: AccessComponentKeyEnum) {
    const menu: IAuthMenu = yield select(makeSelectAuthMenu());

    switch (componentKey) {
        // Заказы и обращения
        case AccessComponentKeyEnum.TabMenuHistory:
            return menu[AuthMenuEnum.ORDERS] && menu[AuthMenuEnum.INQUIRIES];
        case AccessComponentKeyEnum.TabMenuHistoryOrder:
            return menu[AuthMenuEnum.ORDERS] && !menu[AuthMenuEnum.INQUIRIES];
        case AccessComponentKeyEnum.TabMenuHistoryInquiry:
            return menu[AuthMenuEnum.INQUIRIES] && !menu[AuthMenuEnum.ORDERS]
        // Мобильная и фиксированная связь
        case AccessComponentKeyEnum.TabMenuServicesSubscriber:
            return menu[AuthMenuEnum.SUBSCRIBERS_MOBILE];
        // Витрина продуктов и кешбек
        case AccessComponentKeyEnum.TabMenuProducts:
            return menu[AuthMenuEnum.PRODUCTS] && menu[AuthMenuEnum.CASHBACK];
        case AccessComponentKeyEnum.TabMenuProductsOnly:
            return menu[AuthMenuEnum.PRODUCTS] && !menu[AuthMenuEnum.CASHBACK];
        case AccessComponentKeyEnum.TabMenuProductsCashback:
            return !menu[AuthMenuEnum.PRODUCTS] && menu[AuthMenuEnum.CASHBACK];

        default:
            return true;
    }
}
